import React, { useState } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Edit2, ChevronDown, ChevronUp } from 'lucide-react';
import { KPI_CATEGORIES } from './KPIHelpers';

const TemplateCard = ({ template, onEdit, onRefresh, isViewer = false }) => {
  const [expanded, setExpanded] = useState(false);
  const totalWeightage = template.metrics?.reduce((sum, m) => sum + m.weightage, 0) || 0;
  
  return (
    <Card>
      <div 
        className="p-4 cursor-pointer hover:bg-gray-50"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-semibold text-lg">{template.name}</h4>
            <div className="flex gap-2 mt-1">
              {template.department && <Badge variant="outline">Dept: {template.department}</Badge>}
              {template.position && <Badge variant="outline">Position: {template.position}</Badge>}
              <Badge variant="secondary">{template.metrics?.length || 0} metrics</Badge>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {!isViewer && (
              <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); onEdit(); }} data-testid={`edit-template-${template.id}`}>
                <Edit2 className="h-4 w-4" />
              </Button>
            )}
            {expanded ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
          </div>
        </div>
      </div>
      
      {expanded && (
        <div className="border-t p-4 bg-gray-50">
          <div className="grid gap-2">
            {KPI_CATEGORIES.map(cat => {
              const catMetrics = template.metrics?.filter(m => m.category === cat) || [];
              if (catMetrics.length === 0) return null;
              
              return (
                <div key={cat} className="bg-white rounded-lg p-3 border">
                  <h5 className="font-medium text-sm text-gray-700 mb-2">{cat}</h5>
                  <div className="space-y-1">
                    {catMetrics.map(metric => (
                      <div key={metric.id} className="flex justify-between text-sm">
                        <span>{metric.name}</span>
                        <span className="text-gray-500">{metric.weightage}%</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-3 text-right text-sm">
            <span className={totalWeightage === 100 ? 'text-green-600' : 'text-red-600'}>
              Total Weightage: {totalWeightage}%
              {totalWeightage !== 100 && ' (should be 100%)'}
            </span>
          </div>
        </div>
      )}
    </Card>
  );
};

export default TemplateCard;
